module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_09_american-village-b5445ef016e7d5a867c00d11c9c274b0.jpg";